
export function speakersNum(length,heigth,h_techo,h_oreja,alpha,SPL_max,ruido,simulationType){
  return new Promise((resolve, reject) => {
    if(h_techo<=h_oreja){
      reject("Los datos introducidos son erroneos");
    }

    if(alpha>=180)alpha=179;

    //calculo del area
    // const S1 = length*heigth;
    
    let scFactor = 2; //edge to edge
    if(simulationType===2)scFactor=1.5; //minimum overlap
    if(simulationType===3)scFactor=1; //edge to center
    let Sc = Math.pow(scFactor*(h_techo-h_oreja)*(Math.tan((alpha/2)*Math.PI / 180)),2);
    
    //numero de parlantes
    // const n = S1/Sc;

    //radio de covertura de un altavoz
    const Daux = Math.sqrt(Math.pow(2*(h_techo-h_oreja)*(Math.tan((alpha/2)*Math.PI / 180)),2));
    const D = Math.sqrt(Sc);
    // const r = (D/2);
    //numero de altavoces en x
    let nx = length/D;
    nx = Math.round(nx);
    
    //numero de altavoces en y
    let ny = heigth/D;
    ny = Math.round(ny);

    if(length<=(1.5*D)){
      nx=1;
    }
    if(heigth<=(1.5*D)){
      ny=1;
    }
    
    //defino posicion de altavoces
    const X0=length-((((nx+1)*D)+length)/2);
    const X1=((((nx+1)*D)+length)/2);

    const Y0=heigth-((((ny+1)*D)+heigth)/2);
    const Y1=((((ny+1)*D)+heigth)/2);

    const SPx = makeLineSpace(X0,X1,nx+2);
    const SPy = makeLineSpace(Y0,Y1,ny+2);

    const defaultLength=150;
    
    let columnas = defaultLength;//length
    let filas = defaultLength;//heigth
    if(heigth>length)columnas = Number.parseInt((length/heigth)*defaultLength);
    if(length>heigth)filas = Number.parseInt((heigth/length)*defaultLength);
    
    const Xgrid = makeLineSpace(0,length,columnas);
    const Ygrid = makeLineSpace(0,heigth,filas);

    const soundPressure = Array(filas);
    const soundPressureforPrint = Array(Math.round(filas/3));
    let xLabels=[]
    let yLabels=[]
    let xLabelsforPrint=[]
    let yLabelsforPrint=[]
    let minspl=10000;
    let maxspl=0;

    const xLabelStep=length/columnas;
    const yLabelStep=heigth/filas;

    const labelfactor = Number.parseInt((filas*0.1)*(defaultLength/filas))

    for (let i = 0; i < filas; i++) {
      soundPressure[i]=Array(columnas);
      if(i%3===0||i===0) {
        soundPressureforPrint[Math.round(i/3)]=Array(Math.round(columnas/3));
        yLabelsforPrint[Math.abs(Math.round(((filas/3)-(i/3)-1)))]=(Math.round(i/3) % Math.round(labelfactor/3) === 0 ? (i*yLabelStep).toFixed(1) : '');
      }
      yLabels[filas-i-1]=(i % labelfactor === 0 ? (i*yLabelStep).toFixed(1) : '');
      for (let j = 0; j < columnas; j++) {
        let l=0;
        let suma=ruido||0;
        xLabels[j]=(j*xLabelStep).toFixed(1);
        if(i%3===0) xLabelsforPrint[Math.round(j/3)-1]=(Math.round(j/3)*xLabelStep).toFixed(1);
        while (l<nx) {
          let k=0;
          while (k<ny) {
            const distancia = Math.sqrt( Math.pow(( Xgrid[j] - SPx[l+1] ),2) + Math.pow(( Ygrid[i] - SPy[k+1] ),2));
            const h_distancia = Math.sqrt( Math.pow(distancia,2) + Math.pow(h_techo-h_oreja,2));
            const presion = SPL_max - 20*Math.log10(h_distancia);
            suma = 10*Math.log10(Math.pow(10,(suma/10))+Math.pow(10,(presion/10)));
            k++;
          }
          l++;
        }
        soundPressure[i][j]=suma;
        if(suma<minspl)minspl=suma;
        if(suma>maxspl)maxspl=suma;
        if(j%3===0){
          if(i%3===0){
            soundPressureforPrint[Math.round(i/3)][Math.round(j/3)]=suma;
          }
        }
      }
    }
    resolve({
      soundPressure:soundPressure,
      soundPressureforPrint,
      pointsNumx: columnas,
      pointsNumy: filas,
      speakerNumt:nx*ny,
      speakerNumx:nx,
      speakerNumy:ny,
      xLabels: xLabels,
      yLabels: yLabels,
      xLabelsforPrint,
      yLabelsforPrint,
      minspl,
      maxspl,
      SPx,
      SPy,
      length,
      heigth,
      D:Daux,
      defaultLength
    });
  });
}

function makeLineSpace(startValue, stopValue, cardinality) {
  var arr = [];
  var step = (stopValue - startValue) / (cardinality - 1);
  for (var i = 0; i < cardinality; i++) {
    arr.push(startValue + (step * i));
  }
  return arr;
}